import Icon from '@/common/components/Icon';
import styled from 'styled-components';
import { Colors } from '@/common/colors/colors';


export const BellWrapper = styled.div`
	width: 30px;
	height: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	border-radius: 10px;
	position: relative;
`;

export const BellIcon = styled(Icon)`
	color: ${(props) => props.color};
	font-size: 16px;
	position: relative;
`;

export const NotSeenWrapper = styled.div`
	color: ${Colors.red};
	font-size: 12px;
	position: absolute;
	right: 2px;
	top: -5px;
`;